/**
 * Property copy method.
 */
export enum PropertyCopyMethod {
    /**
     * Keep
     */
    Keep = "Keep",

    /**
     * Overwrite
     */
    Overwrite = "Overwrite",

    /**
     * Remove
     */
    Remove = "Remove",

    /**
     * Ignore
     */
    Ignore = "Ignore",
}
